import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axiosInt } from 'library';

import { NOTIFICATIONS_KEY, NOTIFICATIONS_URL } from './notificationsConstants';
import useNotificationOrgId from './useNotificationOrgId';

export const markAllNotificationsReadApi = async (): Promise<{
  updated: number;
}> => (await axiosInt.patch(`${NOTIFICATIONS_URL}/read-all`)).data;

const useMarkAllNotificationsRead = () => {
  const queryClient = useQueryClient();
  const orgId = useNotificationOrgId();

  const { mutate: markAllRead, isPending: isMarkingAllRead } = useMutation<
    { updated: number },
    unknown,
    void
  >({
    mutationFn: markAllNotificationsReadApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [NOTIFICATIONS_KEY, orgId] });
    },
  });

  return { markAllRead, isMarkingAllRead };
};

export default useMarkAllNotificationsRead;
